import React from 'react';

const News = () => {
  return <h1>News Page</h1>;
};

export default News;
